<template>
  <v-dialog
    v-model="isVisible"
    max-width="500"
    :persistent="isLoading"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        outlined
        small
        color="error"
      >
        Supprimer
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="error"
        dark
      >
        <v-btn
          @click="isVisible = false"
          icon
          :disabled="isLoading"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>Supprimer un cours</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pt-5">
        <div>
          Vous êtes sur le point de demander la suppression d'un cours.
        </div>

        <div class="font-weight-bold mt-2">
          Celle-ci sera effective au changement d'année académique.
        </div>

        <div class="mt-2">
          Le cours à supprimer reste actif avec ses utilisateurs (enseignant et étudiants)
          tout au long de l'année académique en cours.
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          text
          block
          :loading="isLoading"
          color="error"
          @click="deleteCursus"
        >
          Supprimer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'DeleteCursusDialog',

  props: {
    cursus: Object,
  },

  data: () => ({
    isVisible: false,
    isLoading: false,
  }),

  methods: {
    ...mapMutations({ showNotification: 'SET_NOTIFICATION' }),

    async deleteCursus() {
      try {
        this.isLoading = true;
        const data = new FormData();
        data.append('idnumber', this.cursus.id_number);
        await this.$http.post('management/delete_course.php', data);
        this.showNotification({
          isVisible: true,
          text: 'La suppression du cours a été prise en compte',
          color: 'success',
        });
        this.isVisible = false;
      } catch (error) {
        this.showNotification({
          isVisible: true,
          text: 'Une erreur est survenue, réessayez',
          color: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
